export default "__VITE_ASSET__C4P0ptYl__"